// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toast-icon-wrapper[data-v-59449c05]{background-color:var(--primary-text);height:3rem;width:3rem}[data-v-59449c05] .v-snack__wrapper{margin:1.6rem}@media (min-width:768px){[data-v-59449c05] .v-snack__wrapper{margin:2.4rem;min-width:40rem}}[data-v-59449c05] .v-snack__content{line-height:normal;padding:.5rem 1.6rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
